<template>
  <div
    class="sn-bs-wrapper"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <main v-if="categoryList.length > 0" class="sn-bs-wrapper__main">
      <div
        class="sn-bs-content-item"
        v-for="(item, index) in categoryList"
        :key="index"
      >
        <div class="sn-bs-content-item-left">
          <img
            class="sn-bs-content-item-left__img"
            :src="setImgUrl(item.imgUrl, 50, 50)"
            alt=""
          />
          <div class="sn-bs-content-item-info">
            <p class="sn-bs-content-item-info__p">{{ item.cropName }}</p>
            <span class="sn-bs-content-item-info__span">
              {{ item.landAcre }}亩
            </span>
          </div>
        </div>
        <div class="sn-bs-content-item-right">
          <img
            class="sn-bs-content-item-right__img"
            v-if="index < 3"
            :src="rankingImgList[index].imgUrl"
            alt=""
          />
          <p class="sn-bs-content-item-right__p" v-else>{{ index + 1 }}</p>
        </div>
      </div>
    </main>
    <Empty v-else-if="!loading" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { farm } from "@/api/request/snkd.produce";
import Empty from "@/components/bs/BsBoxPanel/Empty";

import { setImgUrl } from "@/utils";

export default {
  name: "BsFarmModule03",
  components: { Empty },
  data() {
    return {
      loading: false,
      rankingImgList: [
        {
          imgUrl: require("@/assets/images/bs/varieties-category/ranking-1.png"),
        },
        {
          imgUrl: require("@/assets/images/bs/varieties-category/ranking-2.png"),
        },
        {
          imgUrl: require("@/assets/images/bs/varieties-category/ranking-3.png"),
        },
      ],
      categoryList: [],
    };
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },
  mounted() {
    this.initModel();
  },
  methods: {
    setImgUrl,
    async initModel() {
      this.loading = true;
      try {
        const { list } = await farm.onPlantingByFarmIdService({
          companyId: this.companyId,
          farmId: this.farmId,
        });
        this.categoryList = list.sort((a, b) => {
          return b.landAcre - a.landAcre;
        });
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@include bs(wrapper) {
  @include utils-full-box();
  padding-left: 10px;
  box-sizing: border-box;

  @include e(main) {
    @include utils-scrollbar();
    @include utils-full-box();
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    @include bs(content-item) {
      flex: 1;
      max-height: calc(33% - 30px);
      margin-top: 10px;
      padding: 10px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: rgba(27, 165, 101, 0.2);

      @include bs(content-item-left) {
        display: flex;
        align-items: center;

        @include e(img) {
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }

        @include bs(content-item-info) {
          margin-left: 12px;
          @include e(p) {
            margin-bottom: 12px;
            font-size: 14px;
            font-weight: 400;
            color: #9dd1d7;
            line-height: 14px;
          }

          @include e(span) {
            font-size: 16px;
            font-weight: bold;
            color: #02cc8e;
            line-height: 14px;
          }
        }
      }

      @include bs(content-item-right) {
        width: 24px;
        height: 24px;
        text-align: center;
        @include e(p) {
          width: 20px;
          height: 20px;
          color: #1d7d3d;
          font-size: 12px;
          font-weight: 400;
          background: #0b3a2f;
          border: 1px solid #165647;
          border-radius: 6px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
